import type { DecompositionMap } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.decomposition";
import { isCjkStroke } from "@-/dev.improve.haniverse.lib.unicode";

export interface DecompositionTreeLayout {
  children: DecompositionTreeLayout[];
  grapheme: string;
  height: number;
  nodeSize: number;
  width: number;
}

/** Stroke cards have one-quarter the area of character cards (40 × 40 versus 80 × 80). */
export function getDecompositionTreeLayout(
  grapheme: string,
  decompositionMap: DecompositionMap,
  strokeGlyphs: ReadonlySet<string>,
  ancestors: readonly string[] = [],
): DecompositionTreeLayout {
  const isStroke = strokeGlyphs.has(grapheme) || isCjkStroke(grapheme);
  const nodeSize = isStroke ? 40 : 80;
  const children = (isStroke ? [] : (decompositionMap.get(grapheme) ?? []))
    .filter((child) => child !== grapheme && !ancestors.includes(child))
    .map((child) =>
      getDecompositionTreeLayout(child, decompositionMap, strokeGlyphs, [...ancestors, grapheme]),
    );
  return {
    children,
    grapheme,
    height:
      nodeSize +
      (children.length > 0 ? 32 + Math.max(...children.map((child) => child.height)) : 0),
    nodeSize,
    width: Math.max(
      nodeSize + 16,
      children.reduce((width, child) => width + child.width, 0),
    ),
  };
}
